import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import MainCalculatorsList from '../../MainCalculators';
import SharedHelmet from '../../Helmet';
import RelatedLinks from '../../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds   } from '../../../Ads';
import PercentageCalculator from './PercentageCalculator';
const BASE_TITLE = 'Calculate Percentage';
const BASE_DESCRIPTION = 'Learn how to';
const BASE_KEYWORDS = 'calculate percentage, calculator, percentage calculation';
const numberToArabic = {
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
    6: 'six',
    7: 'seven',
    8: 'eight',
    9: 'nine',
    10: 'ten',
    11: 'eleven',
    12: 'twelve',
    13: 'thirteen',
    14: 'fourteen',
    16: 'sixteen',
    17: 'seventeen',
    18: 'eighteen',
    19: 'nineteen',
    20: 'twenty',
    21: 'twenty-one',
    22: 'twenty-two',
    23: 'twenty-three',
    24: 'twenty-four',
    26: 'twenty-six',
    27: 'twenty-seven',
    28: 'twenty-eight',
    29: 'twenty-nine',
    30: 'thirty',
    31: 'thirty-one',
    32: 'thirty-two',
    33: 'thirty-three',
    34: 'thirty-four',
    36: 'thirty-six',
    37: 'thirty-seven',
    38: 'thirty-eight',
    39: 'thirty-nine',
    40: 'forty',
    41: 'forty-one',
    42: 'forty-two',
    43: 'forty-three',
    44: 'forty-four',
    45: 'forty-five',
    46: 'forty-six',
    47: 'forty-seven',
    48: 'forty-eight',
    49: 'forty-nine',
    50: 'fifty',
    51: 'fifty-one',
    52: 'fifty-two',
    53: 'fifty-three',
    54: 'fifty-four',
    56: 'fifty-six',
    57: 'fifty-seven',
    58: 'fifty-eight',
    59: 'fifty-nine',
    60: 'sixty',
    61: 'sixty-one',
    62: 'sixty-two',
    63: 'sixty-three',
    64: 'sixty-four',
    65: 'sixty-five',
    66: 'sixty-six',
    67: 'sixty-seven',
    68: 'sixty-eight',
    69: 'sixty-nine',
    70: 'seventy',
    71: 'seventy-one',
    72: 'seventy-two',
    73: 'seventy-three',
    74: 'seventy-four',
    76: 'seventy-six',
    77: 'seventy-seven',
    78: 'seventy-eight',
    79: 'seventy-nine',
    80: 'eighty',
    81: 'eighty-one',
    82: 'eighty-two',
    83: 'eighty-three',
    84: 'eighty-four',
    85: 'eighty-five',
    86: 'eighty-six',
    87: 'eighty-seven',
    88: 'eighty-eight',
    89: 'eighty-nine',
    90: 'ninety',
    91: 'ninety-one',
    92: 'ninety-two',
    93: 'ninety-three',
    94: 'ninety-four',
    95: 'ninety-five',
    96: 'ninety-six',
    97: 'ninety-seven',
    98: 'ninety-eight',
    99: 'ninety-nine',
    100: 'one hundred'
};
function getArabicNumber(number) {
    if (number <= 0) return 'Invalid number';
    if (number <= 20) return numberToArabic[number] || `Number ${number} not found`;
    if (number < 100) {
        const tens = Math.floor(number / 10) * 10;
        const units = number % 10;
        const tensWord = numberToArabic[tens] || '';
        const unitsWord = numberToArabic[units] || '';
        if (units === 0) {
            return tensWord;
        } else if (unitsWord) {
            return `${unitsWord} and ${tensWord}`;
        } else {
            return `Number ${number} not found`;
        }
    }
    return numberToArabic[100] || 'Number 100 not found';
}
function PercentageConverter() {
    const { percentage } = useParams();
    const validPercentage = Number(percentage);
    const [amount ] = useState(100);
    const arabicPercentage = getArabicNumber(validPercentage);
    useEffect(() => {
    }, [validPercentage, amount]);
    const TITLE = `${BASE_TITLE} ${validPercentage}% of a number - ${validPercentage} percent calculator`;
    const DESCRIPTION = `${BASE_DESCRIPTION} calculate ${validPercentage}% of a number - ${arabicPercentage} percent calculator - calculate how much ${arabicPercentage} percent is. This calculator calculates the value and percentage of ${validPercentage}% of a certain amount or value`;
    const KEYWORDS = `${BASE_KEYWORDS}, ${validPercentage}%, calculate ${validPercentage}%, ${validPercentage}% calculator, how to calculate ${validPercentage}%, ${validPercentage}% of a number, how to calculate ${validPercentage} percent, calculate ${validPercentage}% of a value, ${validPercentage}% calculator, learn to calculate ${validPercentage}%, ${validPercentage}% calculation steps, how to calculate ${validPercentage}%, ${validPercentage} percent of a value, ${validPercentage}% percentage, best ${validPercentage}% calculator, ${validPercentage}% calculator, ways to calculate percentage, ${validPercentage}% calculations, how to calculate ${validPercentage}% of a number, ${validPercentage}% of a number calculator, percentage calculator`;
    const OG_URL = `https://do-calculate.com/calculator/en/percentage_converter/${validPercentage}`;
    return (
        <div >
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <h2 style={{ fontSize: '17px' }}>To calculate ${validPercentage}% of a certain value, you can follow these steps:</h2>
                                <ul>
                                    <li>Multiply the value by ${validPercentage}% as a fraction. ${validPercentage}% can be represented as a fraction like this: ${validPercentage}/100.</li>
                                    <li>Then multiply the original value by the percentage fraction. Let's say you have a certain value you want to calculate ${validPercentage}% of, let's say this value is ${amount}, you can use the following formula:
                                        <br />
                                        percentage = (original value × fraction ${validPercentage}/100)
                                    </li>
                                    <li>You will get the final result representing ${validPercentage}% of the original value.</li>
                                </ul>
                            </div>
                        </div>
                        <MobileUnderCalAds/>
                        <div className="row">
                            <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '16px' }}>{TITLE}</h2>
                                </div>
                                <hr />
                                <PercentageCalculator percentage={validPercentage} />
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className='alert alert-info'>
                                You can also use <a href="/calculator/en/percentage/">Percentage Calculator</a> to calculate the percentage of any number and calculate percentage increase and decrease.
                            </div>
                            <hr />
                            <hr />
                        </div>
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList/>
                    <br />
                </div>
            </div>
            <br />
        </div>
    );
}
export default PercentageConverter;
